import { motion } from "framer-motion";
import { Label } from "../ui/label";
import { Package, Check } from "lucide-react";

const STEP_ANIMATION = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

const INVENTORY_SIZES = [
  { value: "small", label: "Small (few items)", description: "A few boxes and small furniture" },
  { value: "medium", label: "Medium (1-2 rooms)", description: "Typical 1-bedroom flat contents" },
  { value: "large", label: "Large (3-4 rooms)", description: "2-3 bedroom house contents" },
  { value: "very_large", label: "Very Large (5+ rooms)", description: "Large house or multiple rooms" },
];

const LARGE_ITEM_OPTIONS = ["Sofa", "Bed", "Wardrobe", "Dining Table", "Desk", "Fridge/Freezer", "Washing Machine", "Dishwasher"];

export const StepInventory = ({ formData, updateFormData, toggleArrayItem }) => (
  <motion.div key="step3" {...STEP_ANIMATION} className="space-y-6">
    <div className="text-center mb-8">
      <div className="w-16 h-16 bg-[#FF5A1F]/10 mx-auto flex items-center justify-center mb-4">
        <Package className="w-8 h-8 text-[#FF5A1F]" />
      </div>
      <h2 className="text-2xl font-['Outfit'] font-bold text-[#0F172A]">Inventory Size</h2>
      <p className="text-slate-600 mt-2">How much stuff are we moving?</p>
    </div>

    <div className="space-y-3">
      {INVENTORY_SIZES.map((size) => (
        <button
          key={size.value}
          onClick={() => updateFormData("inventory_size", size.value)}
          className={`w-full p-4 border text-left transition-all ${
            formData.inventory_size === size.value
              ? "border-[#FF5A1F] bg-[#FF5A1F]/5"
              : "border-slate-200 hover:border-slate-300"
          }`}
          data-testid={`inventory-${size.value}`}
        >
          <div className="flex items-center justify-between">
            <div>
              <div className="font-semibold text-[#0F172A]">{size.label}</div>
              <div className="text-sm text-slate-600">{size.description}</div>
            </div>
            {formData.inventory_size === size.value && (
              <Check className="w-5 h-5 text-[#FF5A1F]" />
            )}
          </div>
        </button>
      ))}
    </div>

    <div className="pt-4">
      <Label className="label-text">Large Items (select all that apply)</Label>
      <div className="grid grid-cols-2 gap-2 mt-2">
        {LARGE_ITEM_OPTIONS.map((item) => (
          <button
            key={item}
            onClick={() => toggleArrayItem("large_items", item)}
            className={`p-3 text-sm border transition-all ${
              formData.large_items.includes(item)
                ? "border-[#FF5A1F] bg-[#FF5A1F]/5 text-[#0F172A]"
                : "border-slate-200 hover:border-slate-300"
            }`}
            data-testid={`large-item-${item.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  </motion.div>
);
